module.exports = __webpack_public_path__ + "img/60388bb.jpg";